import { URL_KEYS } from "constants/dashboard";
import useRouterSearchParams from "hooks/useRouterSearchParams";

export default function useGetPerPage(defaultLength) {
  const [searchParams] = useRouterSearchParams();
  const length = searchParams.get(URL_KEYS.perPage);

  return Number(length) || Number(defaultLength);
}
